import $ from 'jquery'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'

const obj = bookingHub

$.fn.bhubBlock = function () {
  return this.each(function () {
    const cur = $(this)
    cur.append(obj.loader)
    cur
      .css({
        pointerEvents: 'none',
        userSelect: 'none',
      })
      .addClass('bhub-blocked')
  })
}

$.fn.bhubUnBlock = function () {
  return this.each(function () {
    const cur = $(this)
    cur.find('.bhub-loader').remove()
    cur
      .css({
        pointerEvents: '',
        userSelect: '',
      })
      .removeClass('bhub-blocked')
  })
}

$.fn.bhubBlockButton = function () {
  return this.each(function () {
    const cur = $(this)
    cur.prop('disabled', true)
    cur
      .css({
        pointerEvents: 'none',
        userSelect: 'none',
        width: cur.outerWidth(),
        height: cur.outerHeight(),
        flex: '0 0 auto',
      })
      .addClass('bhub-blocked-button')
    cur.wrapInner('<div class="bhub-blocked-button-contents"></div>')
    cur.find('.bhub-blocked-button-contents').hide()
    cur.append(obj.loader)
  })
}

$.fn.bhubUnBlockButton = function () {
  return this.each(function () {
    const cur = $(this)
    cur.prop('disabled', false)
    cur
      .css({
        pointerEvents: '',
        userSelect: '',
        width: '',
        height: '',
        flex: '',
      })
      .removeClass('bhub-blocked-button')
    cur.find('.bhub-loader').remove()
    cur.find('.bhub-blocked-button-contents').contents().unwrap()
  })
}

$.fn.bhubAddAlert = function (message, type = 'success') {
  return this.each(function () {
    const cur = $(this)
    cur.prepend(`<div class="bhub-alert bhub-alert--${type}">${message}</div>`)
  })
}

$.fn.bhubRemoveAlert = function () {
  return this.each(function () {
    const cur = $(this)
    cur.find('.bhub-alert').remove()
  })
}

$.validator.addMethod('bhubValidPhone', function (_value, element) {
  if (this.optional(element)) return true

  const iti = intlTelInput.getInstance(element)
  return iti ? iti.isValidNumber() : false
})
